import React, { useEffect,useState,useRef, Component } from 'react'
import { connect } from 'react-redux';
//import FullCalendar from 'fullcalendar-reactwrapper';
//import "fullcalendar-reactwrapper/dist/css/fullcalendar.min.css"
//import Fullcalender from '../../common/fullcalender';
// import FullCalendar from '@fullcalendar/react'
// import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!

import { API_BASE_URL } from '../../../config.js'

import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import axios from 'axios'; 
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';



const AttendanceCalendarControl = (props) => {

    const { fixNavbar } = props;
	const [events, setEvents] = useState([]); // State to store calendar events
	const calendarRef = useRef(null); 
  const [loading, setLoading] = useState(true);

    // const events = [
    //     { id: 1, title: "Long Event Title Example", start: "2025-01-07" },
    //     { id: 2, title: "Another Long Title Here", start: "2025-01-08" },
    //   ];


      const renderEventContent = (eventInfo) => {
        // Break the title into multiple lines
        const titleLines = eventInfo.event.title.split(" ");
        return (
          <div>
            {titleLines.map((line, index) => (
              <div key={index} style={{ 
                display: "flex", 
                justifyContent: "center", 
                alignItems: "center", 
                height: "100%", 
                textAlign: "center" 
              }}>{line}</div>
            ))}
          </div>
        );
      };


      
	
		

	// useEffect(() => {
	// 	fetchEvents();
	//   }, []);
	

    const fetchEvents = async (start, end) => {
       
        axios.get(API_BASE_URL +`/attendancecalendar?start_date=${start}&end_date=${end}`,{
          headers: { Authorization: `Bearer ${localStorage.getItem("authToken")}` },
      }
        )
  .then(function (response) {
    setEvents(response.data)
  })
  .catch(function (error) {
    console.log(error);
  });

};

	


      const handleDatesSet = (info) => {
        const start = info.startStr; 
        const start_date=new Date(start).toLocaleDateString("fr-CA")
        
        // ISO format string for the start date
        const end = info.endStr; 
        const end_date=new Date(end).toLocaleDateString("fr-CA")     // ISO format string for the end date
        fetchEvents(start_date, end_date);
      };
	
	  // Handle the datesSet event, which fires when the calendar's view is changed (prev/next)
	  const handleDateChange = (info) => {

		// const start = new Date(dateInfo.startStr).toLocaleDateString("fr-CA");


		const { start, end } = new Date(info).toLocaleDateString("fr-CA");
		// const { start, end } = info;
		fetchEvents(start.toISOString(), end.toISOString());
	  };


    //   const renderEventContent = (eventInfo) => {
    //     return (
    //       <div>
    //         <strong>{test.title}</strong>
    //         <div style={{ fontSize: "0.8em", color: "#666" }}>
    //           {test.extendedProps.details}
    //         </div>
    //       </div>
    //     );
    //   };



	 

	
    return (
        <>
            <div>
                <div className={`section-body ${fixNavbar ? "marginTop" : ""} mt-3`}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header bline">
                                        <h3 className="card-title d-flex align-items-center mb-0" style={{ color: "#1d3a8a", fontWeight: 600 }}>
                                            <i className="fa fa-calendar mr-2" style={{ fontSize: "20px" }} />
                                            Attendance Calendar
                                        </h3>
                                        <div className="card-options">
                                           
                

                                        </div>
                                    </div>
                                    <div className="card-body">
                                       
								    {/* <div style={{ marginBottom: "10px" }}>
										<button onClick={handlePrevClick}>Previous</button>
										<button onClick={handleNextClick}>Next</button>
									</div> */}
	  <div style={{ padding: "20px" }}>
	  {/* <FullCalendar
        plugins={[dayGridPlugin, interactionPlugin]} // Add necessary plugins
        initialView="dayGridMonth" // Set default view
        events={events} // Display fetched events
        datesSet={handleDateChange} // Handle when the date range is changed (prev/next)
      /> */}

<FullCalendar
      plugins={[dayGridPlugin]}
      initialView="dayGridMonth"
      events={events}
      eventContent={renderEventContent}
      datesSet={handleDatesSet} // Triggered whenever the visible date range changes
      aspectRatio={6}
      height={600}
    />






</div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </>
    )
}


function renderEventContent(eventInfo) {
  const { title, extendedProps } = eventInfo.event
  const attnIn = extendedProps.attn_in || ''
  const attnOut = extendedProps.attn_out || ''

  return (
    <div style={{ textAlign: "center" }}>
      <b>{title}</b>
      {attnIn && <div>IN: {attnIn}</div>}
      {attnOut && <div>OUT: {attnOut}</div>}
    </div>
  )
}

const mapStateToProps = (state) => ({
    fixNavbar: state.settings.isFixNavbar
})

const mapDispatchToProps = (dispatch) => ({})
export default connect(mapStateToProps, mapDispatchToProps)(AttendanceCalendarControl);